import { useMemo } from "react";
import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";

export default function useRouter () {
  let location = useLocation();
  let navigate = useNavigate();
  let params = useParams();
  let query = {}

  let searchParams = ((new URLSearchParams(location.search)).entries())
  for (const [key, value] of searchParams) {
    query[key] = value
  }

  return useMemo(() => {
    return {
      push: navigate,
      pathname: location.pathname,
      params,
      query,
      location,
      back: () => navigate(-1)
    };
  }, [params, location, navigate]);
}